(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSliders = (root = document) => {
      root.querySelectorAll('[data-mobile-product-slider]').forEach((slider) => {
        if (slider.dataset.mobileSliderReady === 'true') {
          return;
        }

        const wrapper = slider.closest('.FeaturedCollectionsMobileSliderWrapper');
        const previousButton = wrapper.querySelector('[data-mobile-slider-previous]');
        const nextButton = wrapper.querySelector('[data-mobile-slider-next]');
        let frame;

        const updateButtons = () => {
          const maximumScroll = slider.scrollWidth - slider.clientWidth;
          previousButton.disabled = slider.scrollLeft <= 2;
          nextButton.disabled = slider.scrollLeft >= maximumScroll - 2;
        };

        const move = (direction) => {
          slider.scrollBy({
            left: direction * slider.clientWidth,
            behavior: 'smooth'
          });
        };

        previousButton.addEventListener('click', () => move(-1));
        nextButton.addEventListener('click', () => move(1));
        slider.addEventListener('scroll', () => {
          window.cancelAnimationFrame(frame);
          frame = window.requestAnimationFrame(updateButtons);
        }, { passive: true });
        window.addEventListener('resize', updateButtons);
        slider.dataset.mobileSliderReady = 'true';
        updateButtons();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeSliders());
    } else {
      initializeSliders();
    }

    document.addEventListener('shopify:section:load', (event) => initializeSliders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 640px)');
    const markerPattern = /leg openings for a laid-back shape\./i;

    const initializeReadMore = (root = document) => {
      if (!mobileQuery.matches) {
        return;
      }

      root.querySelectorAll('[data-section-type="featured-product"]').forEach((section) => {
        const description = section.querySelector('.ProductMeta__Description');

        if (!description || description.dataset.mobileReadMoreReady === 'true') {
          return;
        }

        const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
        let textNode;
        let markerMatch;

        while (walker.nextNode()) {
          const match = walker.currentNode.textContent.match(markerPattern);

          if (match) {
            textNode = walker.currentNode;
            markerMatch = match;
            break;
          }
        }

        if (!textNode || !markerMatch) {
          return;
        }

        const range = document.createRange();
        range.setStart(textNode, markerMatch.index + markerMatch[0].length);
        range.setEndAfter(description.lastChild);

        const hiddenContent = range.extractContents();

        if (!hiddenContent.textContent.trim()) {
          return;
        }

        const remainder = document.createElement('div');
        remainder.className = 'FeaturedProductMobileDescriptionRemainder';
        remainder.hidden = true;
        remainder.append(hiddenContent);

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'FeaturedProductMobileReadMore';
        button.textContent = section.dataset.mobileReadMoreLabel;
        button.setAttribute('aria-expanded', 'false');

        button.addEventListener('click', () => {
          remainder.hidden = false;
          button.setAttribute('aria-expanded', 'true');
          button.hidden = true;
        });

        description.append(button, remainder);
        description.dataset.mobileReadMoreReady = 'true';
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeReadMore());
    } else {
      initializeReadMore();
    }

    mobileQuery.addEventListener('change', () => initializeReadMore());
    document.addEventListener('shopify:section:load', (event) => initializeReadMore(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
